import { motion } from "framer-motion";
import { fadeInUp, fadeIn, scaleIn, slideInLeft, slideInRight, viewportOnce } from "@/lib/motion";

const variantMap = {
  "fade-up": fadeInUp,
  fade: fadeIn,
  scale: scaleIn,
  "slide-left": slideInLeft,
  "slide-right": slideInRight,
};

export function AnimatedReveal({ children, variant = "fade-up", delay = 0, className, as = "div" }) {
  const MotionComponent = motion[as] || motion.div;
  const variants = variantMap[variant] || fadeInUp;

  return (
    <MotionComponent
      className={className}
      variants={{
        hidden: variants.hidden,
        visible: {
          ...variants.visible,
          transition: {
            ...variants.visible.transition,
            delay,
          },
        },
      }}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
    >
      {children}
    </MotionComponent>
  );
}
